
import { Component, Vue } from "vue-property-decorator";

interface RingSize {
  name: string;
  diameter: string;
  circumference: string;
}

@Component
export default class RingSizeParams extends Vue {
  public sizes: RingSize[] = [
    { name: 'Size: 6', diameter: '16,5 мм | 0,65 in', circumference: '52 мм | 2,05 in' },
    { name: 'Size: 7', diameter: '17,4 мм | 0,69 in', circumference: '55 мм | 2,17 in' },
    { name: 'Size: 8', diameter: '18,2 мм | 0,72 in', circumference: '57 мм | 2,24 in' },
    { name: 'Size: 9', diameter: '19,0 мм | 0,75 in', circumference: '60 мм | 2,36 in' },
    { name: 'Size: 10', diameter: '19,9 мм | 0,78 in', circumference: '62 мм | 2,44 in' },
    { name: 'Size: 11', diameter: '20,7 мм | 0,81 in', circumference: '65 мм | 2,56 in' },
    { name: 'Size: 12', diameter: '21,5 мм | 0,85 in', circumference: '68 мм | 2,68 in' },
    { name: 'Size: 13', diameter: '22,3 мм | 0,88 in', circumference: '70 мм | 2,76 in' },
  ];
}
